module.exports = __webpack_public_path__ + "static/img/1.164cf04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/draw/1.png
// module id = gNAI
// module chunks = 1